<template>
  <transition name="fade">
    <div
      v-if="isActive"
      class="carousel-content-background"
      v-html="content.image"
    ></div>
  </transition>
</template>

<script>
export default {
  props: {
    content: Object,
    currentSlide: Number,
    index: Number
  },
  computed: {
    isActive() {
      return this.currentSlide === this.index
    }
  }
}
</script>

<style lang="scss">
.carousel-content-background {
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
